import { SyntheticEvent, useState } from "react"
import { RedTab, Tab } from "../Tabs/Tabs.styles"
import { Tabs } from "@mui/material"
import { useAppSelector } from "../../app/hooks"
import { selectEnteredInvoiceInformation } from "../../activeScreenSlice"

export interface Props {
  value: number
  handleChange: (event: SyntheticEvent<Element, Event>, value: any) => void
}

export default function InvoiceDetailNav(props: Props) {
  const invoiceInputs = useAppSelector(selectEnteredInvoiceInformation)
  const isNonPOSupplier =
    invoiceInputs.nonPoAttribute.toLowerCase().includes("no po supplier") ||
    invoiceInputs.nonPoAttribute.toLowerCase().includes("non-po supplier")
  const isNonPoValidationRuleEnabled = invoiceInputs.isNonPoValidationRuleEnabled
  return (
    <Tabs
      value={props.value}
      onChange={props.handleChange}
      variant="scrollable"
      scrollButtons="auto"
      TabIndicatorProps={{ style: { display: "none" } }}
      sx={{
        background: 'var(--background-off-white)',
        p: "4px",
        borderRadius: "8px",
        minHeight: 0,
        display: 'inline-flex',
        "& .MuiTab-root": {
          minHeight: 0,
          minWidth: 0,
          textTransform: "none",
          fontWeight: 500,
          fontSize: 14,
          color: "#333",
          lineHeight: "18px",
          px: 2,
          py: .75,
          mr: .75,
          borderRadius: "10px",
          background: "transparent",
          transition: "background 0.2s",
          '&:last-child': {
            mr: 0,
          }
        },
        "& .Mui-selected": {
          fontWeight: 700,
          color: '#111111 !important',
          fontSize: 14,
          background: "#fff",
          borderRadius: '6px',
        },
      }}
    >
      <Tab label="Invoice & email" value={1} />
      <Tab label="Line details" value={2} />
      <Tab label="Invoice activity log" value={3} />
      {/* @todo: no type for this value */}
      {isNonPOSupplier && isNonPoValidationRuleEnabled &&(
        invoiceInputs.nonPoRequester !== "" ? (
        <Tab label="Non PO Requester" value={4} />
      ) : (
        <RedTab label="Non PO Requester" value={4} />
      ))
      }
    </Tabs>
  )
}
